import { apiClient } from "@/config/api";
import {
  BlogPost,
  CreateBlogPostDto,
  UpdateBlogPostDto,
  GetPaginationBlogPostsDto,
  BlogPostListResponse,
} from "@/types/blog-post";
import { ApiResponse } from "@/types/status";

const BLOG_POST_ENDPOINTS = {
  CREATE: "/blog-posts",
  GET_ALL: "/blog-posts",
  GET_BY_ID: (id: string) => `/blog-posts/${id}`,
  GET_BY_SLUG: (slug: string) => `/blog-posts/slug/${slug}`,
  UPDATE: (id: string) => `/blog-posts/${id}`,
  DELETE: (id: string) => `/blog-posts/${id}`,
  CHANGE_STATUS: (id: string) => `/blog-posts/${id}/status`,
  TOGGLE_DISPLAY: (id: string) => `/blog-posts/${id}/toggle-display`,
} as const;

export const blogPostService = {
  // Tạo bài viết mới
  create: async (
    data: FormData | CreateBlogPostDto
  ): Promise<ApiResponse<BlogPost>> => {
    return await apiClient.post(BLOG_POST_ENDPOINTS.CREATE, data);
  },

  // Lấy danh sách bài viết với phân trang
  getPaginationBlogPosts: async (
    params: GetPaginationBlogPostsDto
  ): Promise<ApiResponse<BlogPostListResponse>> => {
    // Truyền thẳng params (không bọc trong { params }) để tránh ?params=[object Object]
    return await apiClient.get(BLOG_POST_ENDPOINTS.GET_ALL, params as any);
  },

  // Lấy tất cả bài viết
  getAllBlogPosts: async (): Promise<ApiResponse<BlogPost[]>> => {
    return await apiClient.get(BLOG_POST_ENDPOINTS.GET_ALL);
  },

  // Lấy bài viết theo ID
  getBlogPostById: async (id: string): Promise<ApiResponse<BlogPost>> => {
    return await apiClient.get(BLOG_POST_ENDPOINTS.GET_BY_ID(id));
  },

  // Lấy bài viết theo slug
  getBlogPostBySlug: async (slug: string): Promise<ApiResponse<BlogPost>> => {
    return await apiClient.get(BLOG_POST_ENDPOINTS.GET_BY_SLUG(slug));
  },

  // Cập nhật bài viết
  updateBlogPost: async (
    id: string,
    data: FormData | UpdateBlogPostDto
  ): Promise<ApiResponse<BlogPost>> => {
    return await apiClient.put(BLOG_POST_ENDPOINTS.UPDATE(id), data);
  },

  // Thay đổi trạng thái bài viết
  changeStatus: async (
    id: string,
    status: string
  ): Promise<ApiResponse<BlogPost>> => {
    return await apiClient.put(BLOG_POST_ENDPOINTS.CHANGE_STATUS(id), {
      status,
    });
  },

  // Toggle hiển thị bài viết
  toggleDisplay: async (id: string): Promise<ApiResponse<BlogPost>> => {
    return await apiClient.put(BLOG_POST_ENDPOINTS.TOGGLE_DISPLAY(id));
  },

  // Xóa bài viết
  deleteBlogPost: async (id: string): Promise<ApiResponse<void>> => {
    return await apiClient.delete(BLOG_POST_ENDPOINTS.DELETE(id));
  },
};
